import React from "react";
import ReactApexChart from "react-apexcharts";
import Loader from "../../../components/loader/loder";
import { FaUserMd } from "react-icons/fa";

const DoctorStatsBarChart = ({
                                 dailyActiveDoctors = 0,
                                 totalActiveDoctors = 0,
                                 totalInactiveDoctors = 0,
                                 loading = false
                             }) => {

    const series = [
        {
            name: "Doctors",
            data: [
                dailyActiveDoctors,
                totalActiveDoctors,
                totalInactiveDoctors
            ]
        }
    ];

    const options = {
        chart: {
            type: "bar",
            height: 500,
            toolbar: { show: false },
            fontFamily: "Inter, sans-serif"
        },
        plotOptions: {
            bar: {
                borderRadius: 6,
                columnWidth: "45%",
                distributed: true
            }
        },
        colors: [
            "#22c55e", // today active - green
            "#3b82f6", // total active - blue
            "#9ca3af"  // inactive - gray
        ],
        dataLabels: {
            enabled: true,
            style: {
                fontSize: "13px",
                fontWeight: 600,
                colors: ["#000000"]
            },
            background: {
                enabled: true,
                borderRadius: 6,
                padding: 6,
                opacity: 0.95
            }
        },
        xaxis: {
            categories: [
                "Today Active",
                "Total Active",
                "Inactive"
            ],
            labels: {
                style: {
                    fontSize: "12px",
                    colors: "#6b7280"
                }
            }
        },
        yaxis: {
            enabled: false,
            labels: {
                style: {
                    fontSize: "12px",
                    colors: "#6b7280"
                }
            }
        },
        grid: {
            borderColor: "#e5e7eb",
            strokeDashArray: 10
        },
        tooltip: {
            y: {
                formatter: (val) => `${val} doctors`
            }
        }
    };

    return (
        <div className="p-5">
            <div className="flex items-center gap-2 mb-4">
                <FaUserMd className="text-primary" />
                <h3 className="text-lg font-semibold text-gray-700">
                    Doctor Statistics
                </h3>
            </div>

            {loading ? (
                <div className="h-64 flex items-center justify-center">
                    <Loader />
                </div>
            ) : (
                <div className="grid grid-cols-1 md:grid-cols-3 items-center justify-between">
                    <div className="w-full flex flex-col gap-5">
                        <div className="flex gap-3 items-start">
                            <div className="flex justify-center items-center rounded-md p-3 bg-green-100 text-green-500">
                                <FaUserMd className="w-5 h-5" />
                            </div>
                            <span className="flex flex-col">
                                <p className="text-[16px] font-medium text-primary">Todays Active Doctor</p>
                                <p className="text-2xl font-bold">{dailyActiveDoctors}</p>
                            </span>
                        </div>

                        <div className="flex gap-3 items-start">
                            <div className="flex justify-center items-center rounded-md p-3 bg-blue-100 text-blue-500">
                                <FaUserMd className="w-5 h-5" />
                            </div>
                            <span className="flex flex-col">
                                <p className="text-[16px] font-medium text-primary">Total Active Doctor</p>
                                <p className="text-2xl font-bold">{totalActiveDoctors}</p>
                            </span>
                        </div>

                        <div className="flex gap-3 items-start">
                            <div className="flex justify-center items-center rounded-md p-3 bg-gray-100 text-gray-600">
                                <FaUserMd className="w-5 h-5" />
                            </div>
                            <span className="flex flex-col">
                                <p className="text-[16px] font-medium text-primary">Total Inactive Doctor</p>
                                <p className="text-2xl font-bold">{totalInactiveDoctors}</p>
                            </span>
                        </div>
                    </div>
                    <div className="col-span-2 w-full">
                        <ReactApexChart
                            options={options}
                            series={series}
                            type="bar"
                            height={300}
                        />
                    </div>
                </div>

            )}
        </div>
    );
};

export default DoctorStatsBarChart;
